module.exports = __webpack_public_path__ + "img/sclsk.b7fea042.png";